import { computed, ref } from 'vue'
import { useTemplateStore } from 'src/stores'
import { TemplateBackgroundTypeEnum } from 'src/common/enums'

export default function useBaseTemplateMainSectionHook(props) {
  const templateStore = useTemplateStore()
  const currentDate = Date.now()

  // this ref use when the item is active and we want to change the position of element
  // so i add this variable to pass transition class when its not dragging because its buggy when we put transition and drag element
  const hasItemTransitionRef = ref(true)
  const isLayerMovingRef = ref(false)
  const isLayerActiveRef = computed(() => templateStore.activeLayer.index === props.layerIndex)

  const backgroundStyle = computed(() =>
    templateStore.isDigitalMenu
      ? templateStore.backgroundType === TemplateBackgroundTypeEnum.COLOR
        ? `background-color: ${templateStore.background}`
        : `background: url(${typeof templateStore.background === 'string' ? `${templateStore.background}?t=${Date.now()}` : templateStore.background.blob}) center center / cover no-repeat`
      : '',
  )

  function handleItemMoveStart(item) {
    templateStore.handleActiveLayer({
      index: props.layerIndex,
      id: props.layer.id,
      updatedFrom: 'section',
    })
    templateStore.handleActiveItem(item)
    hasItemTransitionRef.value = false
  }
  function handleResize($event) {
    if ($event.type !== 'dragend') isLayerMovingRef.value = true

    templateStore.handleActiveLayer({
      index: props.layerIndex,
      id: props.layer.id,
      updatedFrom: 'section',
    })
    if ($event.screenX) {
      const elementHeight = $event.srcElement.getBoundingClientRect().height
      const height = props.layer.height + $event.layerY - elementHeight
      templateStore.handleResizeLayer({
        layerIndex: props.layerIndex,
        height: height > 0 ? height : 0,
      })
    }

    if ($event.type === 'dragend') isLayerMovingRef.value = false
  }
  function handleItemMove($event, itemIndex) {
    if ($event.screenX) {
      const htmlElement = document.documentElement
      const zoomLevel = Number(window.getComputedStyle(htmlElement).getPropertyValue('--zoom') ?? 1)
      // NOTE: this is hardcoded because of KCircleIcon v-bind of KIcon
      const elementWidth = 26

      templateStore.handleMoveItem({
        layerIndex: props.layerIndex,
        y: $event.layerY - 2,
        x: $event.layerX - Number.parseInt(elementWidth * zoomLevel),
        itemIndex,
      })
    }

    if ($event.type === 'dragend') hasItemTransitionRef.value = true
  }

  return {
    templateStore,
    currentDate,
    hasItemTransitionRef,
    isLayerMovingRef,
    isLayerActiveRef,
    backgroundStyle,
    handleResize,
    handleItemMove,
    handleItemMoveStart,
  }
}
